import { Stack, Typography } from '@mui/material';
import { type ReactNode } from 'react';

export interface InfoRowProps {
  label: string;
  fontSize: string;
  children: ReactNode;
}

export const InfoRow = ({ label, fontSize, children }: InfoRowProps) => (
  <Stack
    direction="row"
    alignItems="flex-start"
    justifyContent="space-between"
    spacing={0.75}
  >
    <Typography
      variant="body2"
      noWrap
      fontSize={fontSize}
      sx={{ flexShrink: 0 }}
    >
      {label}:
    </Typography>
    <Stack
      direction="row"
      spacing={0.75}
      alignItems="flex-start"
      sx={{ minWidth: 0 }}
    >
      {children}
    </Stack>
  </Stack>
);
